document.addEventListener('DOMContentLoaded', function () {
    const toggleFormButton = document.getElementById('toggleFormButton');
    const newsletterForm = document.getElementById('newsletterForm');

    const toggleFormButtonFooter = document.getElementById('toggleFormButtonFooter');
    const newsletterFormFooter = document.getElementById('newsletterFormFooter');

    toggleFormButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (newsletterForm.style.display === 'block') {
            newsletterForm.style.display = 'none';
        } else {
            newsletterForm.style.display = 'block';
            newsletterFormFooter.style.display = 'none'; // Close the footer form
        }
    });

    toggleFormButtonFooter.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (newsletterFormFooter.style.display === 'block') {
            newsletterFormFooter.style.display = 'none';
        } else {
            newsletterFormFooter.style.display = 'block';
            newsletterForm.style.display = 'none'; // Close the other form
        }
    });

    document.addEventListener('click', function (event) {
        if (newsletterForm.style.display === 'block' && !newsletterForm.contains(event.target) && event.target !== toggleFormButton) {
            newsletterForm.style.display = 'none';
        }

        if (newsletterFormFooter.style.display === 'block' && !newsletterFormFooter.contains(event.target) && event.target !== toggleFormButtonFooter) {
            newsletterFormFooter.style.display = 'none';
        }
    });

    newsletterFormFooter.addEventListener('click', function (event) {
        event.stopPropagation();
    });
});
